import styles from './index.module.scss';

export const getGridBoxClassName = (args: {
  hasMemberPrice: boolean;
  hasMemberPoint: boolean;
  showAmountColumn: boolean;
}) => {
  const { hasMemberPrice, hasMemberPoint, showAmountColumn } = args;

  let numberOfColumns = 1;

  if (hasMemberPrice) {
    numberOfColumns += 1;
  }
  if (hasMemberPoint) {
    numberOfColumns += 1;
  }
  if (showAmountColumn) {
    numberOfColumns += 1;
  }

  switch (numberOfColumns) {
    case 3:
      return `${styles.grid} ${styles['grid-3-columns']}`;
    case 4:
      return `${styles.grid} ${styles['grid-4-columns']}`;
    default:
      return styles.grid;
  }
};

export const getSelectAmountOptions = (maxSelectableAmount: number) => {
  const options = Array.from(
    { length: maxSelectableAmount + 1 },
    (_, number) => ({
      label: number,
      value: number,
    })
  );
  return options;
};
